var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRecentlyUsed = function SvgRecentlyUsed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.5,
    stroke: "#7A7359",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7359",
    strokeLinecap: "round",
    d: "M12 7v5l3 1"
  })));
};
export { SvgRecentlyUsed as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjcuNSIgc3Ryb2tlPSIjN0E3MzU5IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48cGF0aCBzdHJva2U9IiM3QTczNTkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTEyIDd2NWwzIDEiLz48L3N2Zz4=";